// @flow

export default {
  dashboardComments: (id: number) => `/financing_processes/${id}/comments`,
  getDashboardActions: (id: number) => `/financing_processes/${id}/dashboard_actions/index`,
  getFinancingProcesses: `/financing_processes`,
  getInquiryProcess: (id: number) => `/financing_processes/${id}`,
  loanProcess: (id: number) => `/financing_processes/${id}`,
  inquiryFidesData: (id: number) =>
    `/financing_processes/${id}/guarantee_responses/products/fides_data`,
  archiveInquiry: (id: number) => `/financing_processes/${id}/archive`,
  setGuaranteeAgent: (id: number) =>
    `/financing_processes/${id}/dashboard_actions/assign_guarantee_agent`,
  setCreatorFeedback: (id: number) =>
    `financing_processes/${id}/dashboard_actions/set_creator_feedback`,
  confirmCall: (id: number) =>
    `financing_processes/${id}/dashboard_actions/set_welcome_call_performed`,
  confirmDocuments: (id: number) =>
    `/financing_processes/${id}/dashboard_actions/set_documents_confirmed`,
  submitInterest: (id: number) =>
    `financing_processes/${id}/dashboard_actions/set_guarantee_interest`,
  triggerFidesTransfer: (id: number) =>
    `financing_processes/${id}/dashboard_actions/trigger_fides_sync`,
  activityLog: (id: number) => `/financing_processes/${id}/logged_activities`,
  bankAdvisorInquiries: () => "/financing_processes",
  downloadOkpSummary: (okpUid: string) =>
    `/financing_requests/okp_financing_requests/${okpUid}/summary_pdf`,
  downloadSummaryPdf: (id: string) =>
    `/financing_processes/${id}/guarantee_responses/products/guarantee_request_pdf`,
  getGuaranteeResponseProducts: (id: string) =>
    `/financing_processes/${id}/guarantee_responses/products`,
  downloadGuaranteeCertificate: (id: string) =>
    `/financing_processes/${id}/guarantee_responses/products/guarantee_certificate`,
  downloadBankSummary: (id: string) =>
    `/financing_requests/bank_financing_requests/${id}/summary_pdf`,
  getFileRequests: (id: string) => `/financing_processes/${id}/file_requests`,
  requestFile: (id: string) => `/financing_processes/${id}/file_requests`,
  files: (id: string) => `/financing_processes/${id}/financing_requests/file_uploads`,
  uploadFile: (id: string) => `/financing_processes/${id}/financing_requests/file_uploads`,
  file: (id: string, fileUploadId: string) =>
    `/financing_processes/${id}/financing_requests/file_uploads/${fileUploadId}`,
  erpRequestPdf: (financingProcessId: string, productId: string) =>
    `/financing_processes/${financingProcessId}/guarantee_responses/products/${productId}/erp_request_pdf`
};
